// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1bjaj","title":"Images90_title__3dwkN","images":"Images90_images__3Ko8N"};